<template>
  <v-btn text @click.prevent="onClick" color="secondary">
    Back
  </v-btn>
</template>

<script>
/**
 * Renders the 'back' button
 */
export default {
  name: 'LoginBoxActionButtonBack',
  methods: {
    onClick () {
      this.$emit('goBack')
    }
  }
}
</script>

<style scoped>

</style>
